import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) => {
  return createStyles({
    root: {
      display: 'inline-block',
      position: 'relative',

      '&:hover': {
        '& $proBadge': {
          opacity: 0.2,
        },
      },
    },
    tooltip: {},
    avatar: {
      alignItems: 'center',
      border: `1px solid ${colors.grey.lightish}`,
      borderRadius: '50%',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      marginBottom: spacing(3),
      width: '100%',
    },
    noImage: {
      alignItems: 'center',
      border: `1px solid ${colors.grey.lightish}`,
      borderRadius: '50%',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      marginBottom: spacing(3),
      width: '100%',
    },
    noImageInitials: {
      borderRadius: '50%',
      flexWrap: 'nowrap',
      fontWeight: 600,
      height: '100%',
      userSelect: 'none',
      width: '100%',
    },
    name: {
      fontSize: 17,
      fontWeight: 600,
    },
    proBadge: {
      bottom: -4,
      boxShadow: '0 -2px 3px 0 rgb(0 18 52 / 20%)',
      left: '50%',
      opacity: 1,
      position: 'absolute',
      transform: 'translateX(-50%)',
      transition: 'opacity 0.2s ease-in-out',
      userSelect: 'none',
    },
  });
};
